import urls from "../../../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../../../utils/service";

export async function getTeamList() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETTEAMMETALIST, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function addTeam(payload: any) {
  try {
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(urls.ADDTEAMMETA, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updateTeam(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATETEAMMETA, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function updateDepartment(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATEDEPARTMENTMETA, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function editDepartment(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.EDITDEPARTMENTMETA, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getAllSalesHead() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETALLSALESHEAD, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getAllManagerByTeamWise(idd?: String) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETALLMANAGERBYTEAMWISE + idd,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllManagerByRole(id: any) {
  const body = { role_id: id };
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.GETALLMANAGERBYROLE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function deleteTeam(teamId: string) {
  try {
    const callParams = await getCallParams("DELETE");
    const response = await makeCall(
      urls.DELETETEAM + teamId,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllDepartment() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETALLDEPARTMENT, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}